import { parseDate } from "helpers/date";
import { parsePrice } from "helpers/price";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import styled from "styled-components";
import {
  ITermsAcceptance,
  TermsAcceptanceContext,
} from "types/TermsAcceptance/TermsAcceptance";

const ACCEPTANCE_CONTEXT_LABELS: Record<TermsAcceptanceContext, string> = {
  [TermsAcceptanceContext.FullPayment]: "Full Payment",
  [TermsAcceptanceContext.DownPayment]: "Down Payment",
  [TermsAcceptanceContext.PayRemaining]: "Pay Remaining Amount",
};

const StyledDialog = styled(Dialog)`
  width: 60vw;
  max-width: 900px;

  @media (max-width: 720px) {
    width: 95vw;
  }
`;

interface ITermsAcceptancesDialogProps {
  visible: boolean;
  onClose: () => void;
  termsAcceptances: ITermsAcceptance[];
  onDownload: (termsAcceptance: ITermsAcceptance) => void;
}

export function TermsAcceptancesDialog({
  visible,
  onClose,
  termsAcceptances,
  onDownload,
}: ITermsAcceptancesDialogProps) {
  const renderContext = (row: ITermsAcceptance) =>
    ACCEPTANCE_CONTEXT_LABELS[row.acceptanceContext] ?? row.acceptanceContext;

  const renderAcceptedBy = (row: ITermsAcceptance) => {
    if (!row.userId) return "Patient";
    return row.user?.name ?? "—";
  };

  const renderAmount = (row: ITermsAcceptance) =>
    row.amountInCents != null ? parsePrice(row.amountInCents / 100) : "—";

  const renderAcceptedAt = (row: ITermsAcceptance) =>
    parseDate(row.createdAt, false, true);

  const renderDownload = (row: ITermsAcceptance) => (
    <Button
      icon="pi pi-download"
      className="p-button-text p-button-primary p-0"
      onClick={() => onDownload(row)}
    >
      <span className="ml-2 text-sm">Download</span>
    </Button>
  );

  return (
    <StyledDialog
      header="Terms Acceptances"
      visible={visible}
      onHide={onClose}
      dismissableMask
    >
      <DataTable
        value={termsAcceptances}
        dataKey="id"
        emptyMessage="No terms acceptances"
      >
        <Column header="Context" body={renderContext} />
        <Column header="Accepted By" body={renderAcceptedBy} />
        <Column header="Amount" body={renderAmount} />
        <Column header="Date of Acceptance" body={renderAcceptedAt} />
        <Column header="" body={renderDownload} />
      </DataTable>
    </StyledDialog>
  );
}
